// #1205 — a manager can hide the organization's Kalshi and Polymarket account
// balances from a trader. The relay then answers that trader's balance reads
// with 403 ORG_BALANCE_HIDDEN instead of the figure. That is a named
// permission state, never a zero, a missing credential, a disconnected venue
// or a temporary failure, and every balance readout shows it the same way.

/** The relay's refusal code (relay/src/services/orgBalanceVisibility.ts). */
export const ORG_BALANCE_HIDDEN = 'ORG_BALANCE_HIDDEN';

/** What a readout shows in place of the amount. */
export const ORG_BALANCE_HIDDEN_LABEL = 'Hidden';

/** The hover on a hidden readout. */
export const ORG_BALANCE_HIDDEN_TITLE =
  'Your manager has hidden organization balances for this login. Trading, limits, positions and P&L are unaffected.';

/** True when a parsed relay error body is the hidden-balance refusal. */
export function isOrgBalanceHiddenBody(body: unknown): boolean {
  return !!body && typeof body === 'object' && (body as { code?: unknown }).code === ORG_BALANCE_HIDDEN;
}
